<template>
	<div class="exception-body error">
		<Toast />
		<div class="exception-panel">
			<div class="error-icon">
				<i class="pi pi-lock" style="font-size: 4rem; color: #ef4444;"></i>
			</div>
			<h1>Accesso Negato</h1>
			<div class="error-message">
				<p class="main-message">
					Non hai i permessi necessari per accedere a questa pagina.
				</p>
				<p v-if="deniedMessage" class="route-info">{{ deniedMessage }}</p>
				<p class="support-message">
					Se ritieni che debba esserti visibile o che sia un errore, 
					contatta il <strong>supporto tecnico</strong>.
				</p>
			</div>
			<div class="actions">
				<router-link to="/">
					<Button icon="pi pi-home" label="Torna alla Home" class="p-button-rounded" />
				</router-link>
			</div>
		</div>
		<div class="exception-footer">
			<img :src="'layout/images/logo-'+ color + '.png'" class="exception-logo"/>
			<img :src="'layout/images/appname-'+ color + '.png'" class="exception-appname"/>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			deniedMessage: '',
			deniedReason: ''
		}
	},
	mounted() {
		// Recupera i messaggi di errore dal sessionStorage
		this.deniedMessage = sessionStorage.getItem('accessDeniedMessage') || '';
		this.deniedReason = sessionStorage.getItem('accessDeniedReason') || '';
		
		// Mostra il toast con dettagli tecnici se disponibili
		if (this.deniedMessage || this.deniedReason) {
			this.$toast.add({
				severity: 'error',
				summary: 'Accesso Negato',
				detail: this.deniedReason || this.deniedMessage,
				life: 6000
			});
			
			// Pulisci i messaggi dopo averli mostrati
			sessionStorage.removeItem('accessDeniedMessage');
			sessionStorage.removeItem('accessDeniedReason');
		}
	},
	computed: {
		color() {
			if (this.$appState.colorScheme === 'light') return 'dark';
			return 'light';
		}
	}
}
</script>

<style scoped>
.exception-panel {
	text-align: center;
	padding: 2rem;
}

.error-icon {
	margin-bottom: 2rem;
	animation: shake 0.5s ease-in-out;
}

@keyframes shake {
	0%, 100% { transform: translateX(0); }
	25% { transform: translateX(-10px); }
	75% { transform: translateX(10px); }
}

.exception-panel h1 {
	font-size: 2.5rem;
	color: #ef4444;
	margin-bottom: 1.5rem;
	font-weight: 600;
}

.error-message {
	max-width: 600px;
	margin: 0 auto 2rem;
	padding: 1.5rem;
	background: rgba(239, 68, 68, 0.05);
	border-radius: 12px;
	border-left: 4px solid #ef4444;
}

.main-message {
	font-size: 1.15rem;
	color: #374151;
	margin-bottom: 1rem;
	line-height: 1.6;
}

.route-info {
	font-size: 0.95rem;
	color: #6b7280;
	margin-bottom: 1rem;
	font-style: italic;
	padding: 0.5rem;
	background: rgba(0, 0, 0, 0.03);
	border-radius: 6px;
}

.support-message {
	font-size: 1rem;
	color: #6b7280;
	line-height: 1.6;
	margin: 0;
}

.support-message strong {
	color: #2563eb;
}

.actions {
	margin-top: 2rem;
}

.actions .p-button {
	padding: 0.75rem 2rem;
	font-size: 1.1rem;
}
</style>
